import { render, staticRenderFns } from "./cleanscore.vue?vue&type=template&id=48ed0895"
import script from "./cleanscore.vue?vue&type=script&lang=js"
export * from "./cleanscore.vue?vue&type=script&lang=js"
import style0 from "./cleanscore.vue?vue&type=style&index=0&id=48ed0895&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports